
import React, { PureComponent } from 'react'
import { Button, Modal, Col, FormGroup } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputText from '../../commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'

class LegalCompanyModal extends PureComponent {
  submitLegalCompany (values) {
    this.props.actions.saveLegalCompanyModal(values, this.props.legalCompanyFields.legalCompanyId)
  }

  render () {
    const { t, showLegalCompanyModal, handleSubmit } = this.props
    const tKey = 'MASTERS.LEGAL_COMPANY_MASTERS.'
    return (
      <Modal id="legalCompanyModal" show={showLegalCompanyModal} onHide={this.props.actions.closeLegalCompanyModal} className="_nf" backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}LEGAL_COMPANY_TITLE`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={ handleSubmit((values) => this.submitLegalCompany(values))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <FormGroup>
              <div className="search-form">
                <Field
                  component={InputText}
                  colWidth={25} // 25, 33, 50, 75, 100 default=25
                  id="cif"
                  name="cif"
                  controlLabel={t(`${tKey}CIF`)}
                  placeholder={t(`${tKey}CIF`)}
                />
                <Field
                  component={InputText}
                  colWidth={75} // 25, 33, 50, 75, 100 default=25
                  id="description"
                  name="description"
                  controlLabel={t(`${tKey}DESCRIPTION`)}
                  placeholder={t(`${tKey}DESCRIPTION`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="commercialRegistry"
                  name="commercialRegistry"
                  controlLabel={t(`${tKey}COMERCIAL_REGISTRY`)}
                  placeholder={t(`${tKey}COMERCIAL_REGISTRY`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="brand"
                  name="brand"
                  controlLabel={t(`${tKey}BRAND`)}
                  placeholder={t(`${tKey}BRAND`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="country"
                  name="country"
                  controlLabel={t(`${tKey}COUNTRY`)}
                  placeholder={t(`${tKey}COUNTRY`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="state"
                  name="state"
                  controlLabel={t(`${tKey}STATE`)}
                  placeholder={t(`${tKey}STATE`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="city"
                  name="city"
                  controlLabel={t(`${tKey}CITY`)}
                  placeholder={t(`${tKey}CITY`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="cp"
                  name="cp"
                  controlLabel={t(`${tKey}CP`)}
                  placeholder={t(`${tKey}CP`)}
                />
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="address"
                  name="address"
                  controlLabel={t(`${tKey}ADDRESS`)}
                  placeholder={t(`${tKey}ADDRESS`)}
                />
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  id="addresses"
                  name="addresses"
                  controlLabel={t(`${tKey}ADDRESSES`)}
                  placeholder={t(`${tKey}ADDRESSES`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="accounts"
                  name="accounts"
                  controlLabel={t(`${tKey}ACCOUNTS`)}
                  placeholder={t(`${tKey}ACCOUNTS`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="representativeName"
                  name="representativeName"
                  controlLabel={t(`${tKey}REPRESENTATIVE_NAME`)}
                  placeholder={t(`${tKey}REPRESENTATIVE_NAME`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="representativeDNI"
                  name="representativeDNI"
                  controlLabel={t(`${tKey}REPRESENTATIVE_DNI`)}
                  placeholder={t(`${tKey}REPRESENTATIVE_DNI`)}
                />
              </div>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button type="submit" className="_Btn new" disabled={this.props.pristine}>
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  if (values) {
    const tKey = 'MASTERS.LEGAL_COMPANY_MASTERS.VALIDATION.'
    if (!values.cif) {
      errors.cif = props.t(`${tKey}CIF`)
    }
    if (!values.description || values.description.length > 100) {
      errors.description = props.t(`${tKey}DESCRIPTION`)
    }
    if (!values.commercialRegistry) {
      errors.commercialRegistry = props.t(`${tKey}COMERCIAL_REGISTRY`)
    }
    if (!values.brand) {
      errors.brand = props.t(`${tKey}BRAND`)
    }
    if (!values.country) {
      errors.country = props.t(`${tKey}COUNTRY`)
    }
    if (!values.city) {
      errors.city = props.t(`${tKey}CITY`)
    }
    if (!values.state) {
      errors.state = props.t(`${tKey}STATE`)
    }
    if (!values.cp) {
      errors.cp = props.t(`${tKey}CP`)
    }
  }

  return errors
}

export default reduxForm({
  form: 'editLegalCompany',
  validate
})(LegalCompanyModal)
